import { Grid, GridItem, Box } from '@chakra-ui/react';
import Unselected from './Unselected';
import Selected from './Selected';
import ElementHeading from '../components/ElementHeading';
import ElementInstructions from '../components/ElementInstructions';
import TitleBox from './Navigation/TitleBox';
import SearchBox from './Navigation/SearchBox';
import BulletNav from './Navigation/BulletNav';

const Bullets = (fieldName, qObj, props, jobSeekerData, isMultiple = false) => {
  const styles = props.stateProps.bulletBankStyles;


  //why do we make newProps
  const newProps = props; //{stateProps: props.stateProps,formikProps: props.formikProps};
  //???
  props.stateProps.bulletData.bulletsLoaded = false;
  return (
    <>
      <ElementHeading qObj={qObj} props={props} />
      <ElementInstructions instructions={qObj.instructions} />
      {/*Ian move this to style*/}
      <Grid
        padding="32px 0"
        templateColumns="repeat(10, 1fr)"
        gap={['20px', null, null, '40px']}
      >
        {/*Left Column*/}
        <GridItem colSpan={[10, null, 5, 6]}>
          <TitleBox props={props} jobSeekerData={jobSeekerData}  />
          <Selected jobSeekerData={jobSeekerData} props={newProps} />
        </GridItem>
        {/* end Left Column*/}

        {/* right column*/}
        <GridItem colSpan={[10, null, 5, 4]}>
          <Box sx={{ ...styles.unselectedWrapper }}>
            <Box sx={{ ...styles.searchContainer }}>
              <SearchBox jobSeekerData={jobSeekerData} props={props} />
            </Box>
            <Box sx={{ ...styles.navContainer }}>
              <BulletNav stateProps={props.stateProps} />
            </Box>
            <Box sx={{ ...styles.unselectedItemsContainer }}>
              <Unselected props={newProps} jobSeekerData={jobSeekerData} classes={styles} />
            </Box>
          </Box>
        </GridItem>
        {/* endright column*/}
      </Grid>
    </>
  );
};

export default Bullets;

